/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HealthDeclarationLandingAliases {
  ACCESSIBILITY_0 = 'accessibility-0',
  APPLICATION_BAR_0 = 'application-bar-0',
  FRAGMENT_FOOTER = 'fragment-footer',
  LAYOUT_1 = 'layout-1',
  LOADER_0 = 'loader-0',
  PANEL_0 = 'panel-0',
  ROOT_COMPONENT = 'root-component',
}
export { HealthDeclarationLandingAliases };
